exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#interactionConfigurationComponent {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n#interactionConfigurationComponent h2 {\r\n  font-family: 'Roboto Condensed';\r\n}\r\n#interactionComponentBody {\r\n  padding: 1rem;\r\n  box-sizing: border-box;\r\n}\r\n#interactionProviders {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n#interactionProviders .interactionBlock {\r\n  margin: 0.5rem;\r\n}\r\nbutton#addNewInteractionProvider {\r\n  background: orangered;\r\n  margin: 0.5rem;\r\n  transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n}", ""]);

// exports
